import { JSX } from "react";

import { Outlet } from "react-router-dom";

function StationDashboardPage(): JSX.Element {
  return <Outlet />;
}

export default StationDashboardPage;
